import { OrderRefundList, OrderShow } from 'pages/financial/order_refunds';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'order_refunds',
  label: 'Reembolso',
  list: OrderRefundList,
  show: OrderShow,
  actions: ['list', 'show', 'create', 'approve'],
  parentName: 'financial'
};

export default generateResources(resource);
